<template>
  <div id="app">
    <turn-book :img-list="imgList" @downLoad="downLoad" />
  </div>
</template>

<script>
  // const pdfPagesType = 'chris'
  const pdfPagesType = 'apparelcatalog'
  import fileSaver from 'file-saver'
  import TurnBook from './components/TurnBook.vue'
  export default {
    name: 'App',
    components: {
      TurnBook,
    },
    data() {
      return {
        imgList: [
          require(`../public/pages/${pdfPagesType}/1.jpg`),
          require(`../public/pages/${pdfPagesType}/2.jpg`),
          require(`../public/pages/${pdfPagesType}/3.jpg`),
          require(`../public/pages/${pdfPagesType}/4.jpg`),
          require(`../public/pages/${pdfPagesType}/5.jpg`),
          require(`../public/pages/${pdfPagesType}/6.jpg`),
          require(`../public/pages/${pdfPagesType}/7.jpg`),
          require(`../public/pages/${pdfPagesType}/8.jpg`),
          require(`../public/pages/${pdfPagesType}/9.jpg`),
          require(`../public/pages/${pdfPagesType}/10.jpg`),
          require(`../public/pages/${pdfPagesType}/11.jpg`),
          require(`../public/pages/${pdfPagesType}/12.jpg`),
          require(`../public/pages/${pdfPagesType}/13.jpg`),
          require(`../public/pages/${pdfPagesType}/14.jpg`),
          require(`../public/pages/${pdfPagesType}/15.jpg`),
          require(`../public/pages/${pdfPagesType}/16.jpg`),
          require(`../public/pages/${pdfPagesType}/17.jpg`),
          require(`../public/pages/${pdfPagesType}/18.jpg`),
          require(`../public/pages/${pdfPagesType}/19.jpg`),
          require(`../public/pages/${pdfPagesType}/20.jpg`),
          require(`../public/pages/${pdfPagesType}/21.jpg`),
          require(`../public/pages/${pdfPagesType}/22.jpg`),
          require(`../public/pages/${pdfPagesType}/23.jpg`),
          require(`../public/pages/${pdfPagesType}/24.jpg`),
          require(`../public/pages/${pdfPagesType}/25.jpg`),
        ],
        // downLoadUrl: './pages/coolerbag/cooler bag catalog.pdf',
        // downLoadName: 'cooler bag catalog.pdf',
        downLoadUrl: './pages/apparelcatalog/apparel catalog.pdf',
        downLoadName: 'apparel catalog.pdf',
      }
    },
    methods: {
      downLoad() {
        fileSaver.saveAs(this.downLoadUrl, this.downLoadName)
      },
    },
  }
</script>
<style>
  #app {
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-color: #fcfcfc;
  }
</style>
